<script setup>
import { computed } from 'vue';

import Icon from './Icon.vue';

defineOptions({ name: 'DsBanner' });

const props = defineProps({
  tone: { type: String, default: 'info' },
  icon: { type: String, default: null },
  title: { type: String, default: null },
  closable: { type: Boolean, default: false }
});

defineEmits(['close']);

const iconName = computed(() => {
  if (props.icon) return props.icon;
  if (props.tone === 'danger' || props.tone === 'warning') return 'alert';
  if (props.tone === 'success') return 'check';
  return 'info';
});

// tone danger → role=alert (anuncio asertivo); el resto status (polite).
const role = computed(() => (props.tone === 'danger' ? 'alert' : 'status'));
</script>

<template>
  <div
    :class="['ds-banner', `ds-banner--${tone}`]"
    :role="role"
  >
    <Icon
      :name="iconName"
      :size="16"
      :stroke="2"
      class="ds-banner__icon"
    />
    <div class="ds-banner__body">
      <div
        v-if="title"
        class="ds-banner__title"
      >
        {{ title }}
      </div>
      <div
        v-if="$slots.default"
        class="ds-banner__text"
      >
        <slot />
      </div>
    </div>
    <div
      v-if="$slots.action"
      class="ds-banner__action"
    >
      <slot name="action" />
    </div>
    <button
      v-if="closable"
      type="button"
      class="ds-banner__close"
      @click="$emit('close')"
    >
      <Icon
        name="x"
        :size="12"
        :stroke="2"
      />
    </button>
  </div>
</template>
